cb.define(['common/common_VM.Extend.js'], function (common) {
    var AA_aa_reson_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name]) {
                this[name](viewmodel);
            }
        },

        init: function (viewmodel) {
            viewmodel.on('afterLoadData', function () {
                if (viewmodel.getParams().mode === 'edit')
                    viewmodel.get('btnSaveAndAdd').setVisible(false)
            })
        },
    }
    try {
        module.exports = AA_aa_reson_VM_Extend;
    } catch (error) {

    }
    return AA_aa_reson_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_reason_VM.Extend.js